'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueSeq = exports.sortBy = exports.some = exports.set = exports.reduce = exports.map = exports.keyedEquivalent = exports.keySeq = exports.has = exports.get = exports.forEach = exports.flattenN = exports.filter = exports.every = exports.entrySeq = exports.concat = exports.count = exports.clear = undefined;

var _always = require('../always');

var _always2 = _interopRequireDefault(_always);

var _isFunction = require('../isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isNumber = require('../isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _protocol = require('../protocol');

var _protocol2 = _interopRequireDefault(_protocol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAnyValue = (0, _always2.default)(true);

var clear = exports.clear = (0, _protocol2.default)({
  args: [_protocol2.default.TYPE],
  name: 'clear'
});

/**
 * @private
 * Returns the number of values in `subject`.
 *
 * @param {TYPE} subject
 * @return {number}
 */
var count = exports.count = (0, _protocol2.default)({
  args: [_protocol2.default.TYPE],
  name: 'count'
});

/**
 * @private
 * Returns a concatenated `subject` and `update`.
 *
 * @param {any} update
 * @param {TYPE} subject
 * @return {number}
 */
var concat = exports.concat = (0, _protocol2.default)({
  args: [isAnyValue, // update
  _protocol2.default.TYPE],
  name: 'concat'
});

/**
 * @private
 * Returns a Seq of key,value tuples (in JS Array)
 *
 * @param {TYPE}
 * @return {Seq<[any, any]>}
 */
var entrySeq = exports.entrySeq = (0, _protocol2.default)({
  args: [_protocol2.default.TYPE],
  name: 'entrySeq'
});

/**
 * @private
 * Returns true if `predicate` returns `true` for _all_ items in `subject`.
 *
 * @param {Function} predicate
 * @param {TYPE} subject
 * @return {bool}
 */
var every = exports.every = (0, _protocol2.default)({
  args: [_isFunction2.default, // predicate
  _protocol2.default.TYPE],
  name: 'every'
});

/**
 * @private
 * Returns a new value of items in `subject` for which `predicate` returns `true`.
 *
 * @param {Function} predicate
 * @param {TYPE} subject
 */
var filter = exports.filter = (0, _protocol2.default)({
  args: [_isFunction2.default, // predicate
  _protocol2.default.TYPE],
  name: 'filter'
});

var flattenN = exports.flattenN = (0, _protocol2.default)({
  args: [_isNumber2.default, // depth
  _protocol2.default.TYPE],
  name: 'flattenN'
});

var forEach = exports.forEach = (0, _protocol2.default)({
  args: [_isFunction2.default, // effect
  _protocol2.default.TYPE],
  name: 'forEach'
});

/**
 * @private
 * Return the value of `key` in `subject`.
 *
 * @param {any} key
 * @param {TYPE} subject
 * @return {any}
 */
var get = exports.get = (0, _protocol2.default)({
  args: [isAnyValue, // key
  _protocol2.default.TYPE],
  name: 'get',
  fallback: function fallback(key, obj) {
    return obj[key];
  }
});

/**
 * @private
 * Returns `true` if `key` is in `subject`'s keys.
 *
 * @param {any} key
 * @param {TYPE} subject
 * @return {any}
 */
var has = exports.has = (0, _protocol2.default)({
  args: [isAnyValue, // key
  _protocol2.default.TYPE],
  name: 'has'
});

/**
 * @private
 * Return a `Seq` of the keys in `subject`.
 *
 * @param {TYPE<K, _>} subject
 * @return {Seq<K>}
 */
var keySeq = exports.keySeq = (0, _protocol2.default)({
  args: [_protocol2.default.TYPE],
  name: 'keySeq'
});

var keyedEquivalent = exports.keyedEquivalent = (0, _protocol2.default)({
  args: [_protocol2.default.TYPE],
  name: 'keyedEquivalent'
});

/**
 * @private
 * Returns a new value by applying `mapper` to each item in `subject`.
 *
 * @param {Function} mapper
 * @param {TYPE} subject
 * @return {TYPE}
 */
var map = exports.map = (0, _protocol2.default)({
  args: [_isFunction2.default, // mapper
  _protocol2.default.TYPE],
  name: 'map'
});

/**
 * @private
 * Returns a new value by applying `mapper` to each item in `subject`.
 *
 * @param {Function} mapper
 * @param {TYPE} subject
 * @return {TYPE}
 */
var reduce = exports.reduce = (0, _protocol2.default)({
  args: [isAnyValue, // accumulator
  _isFunction2.default, // reducer
  _protocol2.default.TYPE],
  name: 'reduce'
});

/**
 * @private
 * Set the `value` of `key` in `subject`.
 *
 * @param {any} value
 * @param {any} key
 * @param {TYPE} subject
 * @return {TYPE}
 */
var set = exports.set = (0, _protocol2.default)({
  args: [isAnyValue, // value
  isAnyValue, // key
  _protocol2.default.TYPE],
  name: 'set'
});

/**
 * @private
 * Returns true if `predicate` returns `true` for _any_ items in `subject`.
 *
 * @param {Function} predicate
 * @param {TYPE} subject
 * @return {bool}
 */
var some = exports.some = (0, _protocol2.default)({
  args: [_isFunction2.default, // predicate
  _protocol2.default.TYPE],
  name: 'some'
});

/**
 * @private
 * Returns a copy of `subject` sorted according to `getSortValue`.
 *
 * @param {Function} getSortValue
 * @param {TYPE} subject
 * @return {TYPE}
 */
var sortBy = exports.sortBy = (0, _protocol2.default)({
  args: [_isFunction2.default, // getSortValue
  _protocol2.default.TYPE],
  name: 'sortBy'
});

/**
 * @private
 * Return a `Seq` of the values in `subject`.
 *
 * @param {TYPE<_, V>} subject
 * @return {Seq<K>}
 */
var valueSeq = exports.valueSeq = (0, _protocol2.default)({
  args: [_protocol2.default.TYPE],
  name: 'valueSeq'
});